// En-tête et pied de page, par langue. Les pages /de/ et /en/ n'ont pas de
// pages villes : leur pied de page renvoie vers la page principale du pays.
import { SITE } from './site';

export const HOME = {
  fr: '/',
  de: '/de/leckortung-luxemburg',
  en: '/en/leak-detection-luxembourg',
};

// Libellé du sélecteur de langue, rédigé dans la langue cible.
export const LANG_NAMES = { fr: 'Français', de: 'Deutsch', en: 'English' };

export const CHROME = {
  fr: {
    tagline: 'Expertise & Détection',
    logoAlt: 'Logo Expomis',
    menu: 'Ouvrir ou fermer le menu',
    languages: 'Langues',
    nav: [
      { to: '/', label: 'Accueil' },
      { to: '/recherche-fuite-luxembourg', label: 'Recherche de fuite' },
      { to: '/expertise-assurance', label: 'Expertise assurance' },
      { to: '/qui-sommes-nous', label: 'Qui sommes-nous' },
      { to: '/contact', label: 'Contact' },
    ],
    cta: { to: '/contact', label: 'Demander une information' },
    about: "Recherche de fuite et expertise d'assurance au Luxembourg et dans le sud de la province de Luxembourg (Belgique).",
    hours: SITE.hours,
    rights: 'Tous droits réservés.',
    columns: [
      {
        title: 'Recherche de fuite',
        links: [
          '/recherche-fuite-canalisation',
          '/recherche-fuite-chauffage',
          '/recherche-fuite-evacuation',
          '/recherche-fuite-douche',
          '/recherche-infiltration',
          '/surconsommation-eau',
          '/techniques',
          '/prix-recherche-fuite',
        ],
      },
      {
        title: "Zones d'intervention",
        // Page principale + villes en ligne, pour garder un lien vers chaque ville
        // depuis toutes les pages sans allonger la colonne.
        groups: [
          {
            path: '/recherche-fuite-luxembourg',
            cities: [
              '/recherche-fuite-luxembourg-ville',
              '/recherche-fuite-esch-sur-alzette',
              '/recherche-fuite-differdange',
              '/recherche-fuite-dudelange',
              '/recherche-fuite-petange',
              '/recherche-fuite-mamer',
              '/recherche-fuite-strassen',
              '/recherche-fuite-bertrange',
              '/recherche-fuite-hesperange',
              '/recherche-fuite-sanem',
              '/recherche-fuite-mersch',
              '/recherche-fuite-ettelbruck',
              '/recherche-fuite-diekirch',
              '/recherche-fuite-wiltz',
              '/recherche-fuite-grevenmacher',
              '/recherche-fuite-remich',
              '/recherche-fuite-echternach',
              '/recherche-fuite-steinfort',
            ],
          },
          {
            path: '/recherche-fuite-province-luxembourg',
            cities: [
              '/recherche-fuite-arlon',
              '/recherche-fuite-aubange',
              '/recherche-fuite-messancy',
              '/recherche-fuite-virton',
            ],
          },
        ],
      },
      {
        title: 'Expertise',
        links: ['/expertise-assurance', '/degat-des-eaux', '/fuite-eau-qui-paie', '/contre-expertise', '/rapport-recherche-fuite'],
        extra: [
          { to: '/services', label: 'Tous nos services' },
          { to: '/qui-sommes-nous', label: 'Qui sommes-nous' },
        ],
      },
    ],
  },
  de: {
    tagline: 'Gutachten & Ortung',
    logoAlt: 'Expomis-Logo',
    menu: 'Menü öffnen oder schließen',
    languages: 'Sprachen',
    nav: [
      { to: '/de/leckortung-luxemburg', label: 'Leckortung' },
      { to: '/de/wasserschaden', label: 'Wasserschaden' },
      { to: '/de/wasserschaden-wer-zahlt', label: 'Wer zahlt?' },
      { to: '/de/kontakt', label: 'Kontakt' },
    ],
    cta: { to: '/de/kontakt', label: 'Anfrage senden' },
    about: 'Leckortung und Versicherungsgutachten in Luxemburg und im Süden der belgischen Provinz Luxemburg.',
    hours: ['Mo-Fr: 9-18 Uhr', 'Samstag: 9-16 Uhr', 'Notdienst: rund um die Uhr'],
    rights: 'Alle Rechte vorbehalten.',
    columns: [
      {
        title: 'Leckortung',
        links: [
          '/de/leckortung-wasserleitung',
          '/de/leckortung-heizung',
          '/de/leckortung-abwasser',
          '/de/leckortung-dusche',
          '/de/ortung-wassereintritt',
          '/de/hoher-wasserverbrauch',
          '/de/leckortung-verfahren',
          '/de/leckortung-kosten',
        ],
      },
      {
        title: 'Einsatzgebiet',
        links: ['/de/leckortung-luxemburg', '/de/leckortung-luxemburg-stadt'],
        note: 'Ganzes Großherzogtum Luxemburg sowie der Süden der belgischen Provinz Luxemburg (Arlon, Aubange, Messancy, Virton).',
      },
      {
        title: 'Gutachten',
        links: ['/de/wasserschaden', '/de/wasserschaden-wer-zahlt'],
        extra: [
          { to: '/de/kontakt', label: 'Kontakt' },
          { to: '/', label: 'Website auf Französisch', lang: 'fr' },
        ],
      },
    ],
  },
  en: {
    tagline: 'Assessment & Detection',
    logoAlt: 'Expomis logo',
    menu: 'Open or close the menu',
    languages: 'Languages',
    nav: [
      { to: '/en/leak-detection-luxembourg', label: 'Leak detection' },
      { to: '/en/water-damage', label: 'Water damage' },
      { to: '/en/water-leak-who-pays', label: 'Who pays?' },
      { to: '/en/contact', label: 'Contact' },
    ],
    cta: { to: '/en/contact', label: 'Request information' },
    about: 'Leak detection and insurance loss assessment in Luxembourg and in the south of the Belgian province of Luxembourg.',
    hours: ['Mon-Fri: 9am-6pm', 'Saturday: 9am-4pm', 'Emergencies: 24/7'],
    rights: 'All rights reserved.',
    columns: [
      {
        title: 'Leak detection',
        links: [
          '/en/water-pipe-leak',
          '/en/heating-leak',
          '/en/drain-leak',
          '/en/shower-leak',
          '/en/water-ingress',
          '/en/high-water-usage',
          '/en/leak-detection-methods',
          '/en/leak-detection-cost',
        ],
      },
      {
        title: 'Service area',
        links: ['/en/leak-detection-luxembourg', '/en/leak-detection-luxembourg-city'],
        note: 'The whole Grand Duchy of Luxembourg and the south of the Belgian province of Luxembourg (Arlon, Aubange, Messancy, Virton).',
      },
      {
        title: 'Loss assessment',
        links: ['/en/water-damage', '/en/water-leak-who-pays'],
        extra: [
          { to: '/en/contact', label: 'Contact' },
          { to: '/', label: 'Website in French', lang: 'fr' },
        ],
      },
    ],
  },
};
